import React, { useEffect, useRef, useState } from "react";
import HomeTopPlaces from "../../components/TopPlaces/HomeTopPlaces";
import {
  Container,
  //   Breadcrumb,
  //   BreadcrumbItem,
  Input,
  Button,
  Form,
  Label,
  FormGroup,
} from "reactstrap";
import {
  // Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  getNextPlaces,
  getNextPlacesUsingDate,
} from "../../services/nextPlaces.services";
import GridView from "../../components/NextPlaces/GridView";
import TableView from "../../components/NextPlaces/TableView";
import { toast } from "react-toastify";
import { MdGridOn } from "react-icons/md";
import { FiList } from "react-icons/fi";
import calender_icon from "../../assets/calende-icon.svg";
import "./style.scss";

function NextPlacesScreen() {
  const [viewName, setViewname] = useState("grid");
  const [searchedData, setSearchedData] = useState([]);
  const [nextPlacesDates, setNextPlacesDates] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (view) => {
    // dispatch(changeView(view))
    setViewname(view);
  };

  const fetchNextPlaces = async () => {
    try {
      let response = await getNextPlaces();
      if (response && response?.status === 200) {
        setSearchedData(response.data);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Oops.. something went wrong, try again !!!",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        }
      );
    }
  };

  useEffect(() => {
    const searchParamsData = location.search.replace("?", "").split("&");
    const queryParams = {};
    searchParamsData?.forEach(
      (item) => (queryParams[item.split("=")[0]] = item.split("=")[1])
    );
    const { startDate, endDate } = queryParams;
    if (startDate && endDate) {
      getNextPlacesUsingDate(startDate, endDate)
        .then((response) => setSearchedData(response.data))
        .catch((err) => console.log(err.message));
    } else {
      fetchNextPlaces();
    }
  }, [location.search]);

  function handleDateChange(event) {
    setNextPlacesDates((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  }

  async function handleDateSearchSubmit(event) {
    event.preventDefault();

    const { startDate, endDate } = nextPlacesDates;

    if (!startDate) {
      return toast.error("Please select start date", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
    }

    if (!endDate) {
      return toast.error("Please select end date", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
    }

    navigate(`/next-places?startDate=${startDate}&endDate=${endDate}`);
  }

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  const openDatePicker = (ref) => {
    if (ref.current) {
      if (ref.current.showPicker) {
        ref.current.showPicker(); // modern browsers
      } else {
        ref.current.focus(); // fallback
      }
    }
  };
  return (
    <div className="main_section cemetery">
        {/* <SearchBar /> */}
        {/* <div className="breadcrumb_section">
          <Container>
          <Breadcrumb className="breadcrumb">
              <BreadcrumbItem>
              <Link to="/" className="breadcrumb_item1">
              Home
              </Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
              <Link to="/" className="breadcrumb_item1">
              Next places
              </Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
              <Link to='/category-list' className="breadcrumb_item2" state={{ categoryName: categoryName, categoryTitle: categoryTitle, categoryIcon: categoryIcon }}>{categoryName}</Link>
              </BreadcrumbItem>
              </Breadcrumb>
              </Container>
        </div> */}
        <HomeTopPlaces />
        <Container>
        <div className="myroutes_section">
          <Container fluid>
            <div className="nt-myroutes_box">
              <h4> יארצייטן</h4>

              <div className="myroutes_box_header">
                <div className="search_input">
                  <Form
                    onSubmit={handleDateSearchSubmit}
                    className="topplace_header_form"
                  >
                    <FormGroup className="topplace_form_input">
                      <Label
                        for="startdate"
                        className="topplace_form_input_label"
                      >
                        From
                      </Label>
                      <div
                        className="topplace_header_input-wrapper"
                        style={{ position: "relative" }}
                      >
                        <Input
                          innerRef={startDateRef}
                          id="startdate"
                          className="topplace_header_input"
                          name="startDate"
                          placeholder="dd/mm/yyyy"
                          type="date"
                          onChange={handleDateChange}
                        />
                        <img
                          src={calender_icon}
                          alt="calendar icon"
                          onClick={() => openDatePicker(startDateRef)}
                          style={{
                            position: "absolute",
                            right: "25px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            width: "20px",
                            height: "20px",
                            pointerEvents: "auto",
                          }}
                        />
                      </div>
                    </FormGroup>

                    <FormGroup className="topplace_form_input ms-3">
                      <Label
                        for="enddate"
                        className="topplace_form_input_label"
                      >
                        To
                      </Label>
                      <div
                        className="topplace_header_input-wrapper"
                        style={{ position: "relative" }}
                      >
                        <Input
                          innerRef={endDateRef}
                          id="enddate"
                          className="topplace_header_input"
                          name="endDate"
                          placeholder="dd/mm/yyyy"
                          type="date"
                          onChange={handleDateChange}
                          min={nextPlacesDates.startDate}
                        />
                        <img
                          src={calender_icon}
                          alt="calendar icon"
                          onClick={() => openDatePicker(endDateRef)}
                          style={{
                            position: "absolute",
                            right: "25px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            width: "20px",
                            height: "20px",
                            pointerEvents: "auto",
                          }}
                        />
                      </div>
                    </FormGroup>

                    <div className="topplace_header_form_button">
                      <button type="submit">
                        <span>Search</span>
                      </button>
                    </div>
                  </Form>
                </div>
                <div className="button_section">
                  <div className="view_btn">
                    <Button
                      name="grid"
                      className={`${
                        viewName === "grid" ? "btn_grid" : "btn_table"
                      }`}
                      onClick={() => handleClick("grid")}
                    >
                      <MdGridOn />
                      Grid View
                    </Button>
                    <Button
                      name="table"
                      className={`${
                        viewName === "table" ? "btn_grid" : "btn_table"
                      }`}
                      onClick={() => handleClick("table")}
                    >
                      <FiList />
                      Table View
                    </Button>
                  </div>
                </div>
              </div>
              <div className="myroutes_block">
                {viewName === "grid" ? (
                  <GridView currentTableData={searchedData} />
                ) : (
                  <TableView currentTableData={searchedData} />
                )}
              </div>
            </div>
          </Container>
        </div>
      </Container>
    </div>
  );
}

export default NextPlacesScreen;
